import React, { useState } from "react";
import { Phone, Menu, X } from "lucide-react";

const PHONE = "+420 775 659 129";

const links = [
  { href: "#hero", label: "Domů", id: "domu" },
  { href: "#sluzby", label: "Služby", id: "sluzby" },
  { href: "#cenik", label: "Ceník", id: "cenik" },
  { href: "#pro-firmy", label: "Pro firmy", id: "pro-firmy" },
  { href: "#pro-seniory", label: "Pro seniory", id: "pro-seniory" },
  { href: "#partner-servis", label: "Partner", id: "partner-servis" },
  { href: "#strategicky-partner", label: "CDX", id: "strategicky-partner" },
  { href: "#o-nas", label: "O nás", id: "o-nas" },
  { href: "#kontakt", label: "Kontakt", id: "kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0D17]/85 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between gap-6">
          <a
            href="#hero"
            data-testid="logo-link"
            className="flex items-center gap-3 group shrink-0"
          >
            <span
              className="block h-12 w-12 rounded-xl bg-[#0A0D17] ring-1 ring-amber-300/20 shadow-[0_8px_24px_-8px_rgba(212,175,55,0.35)] transition-transform group-hover:-translate-y-0.5"
              style={{
                backgroundImage: "url(/brand/logo.png)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "150% auto",
                backgroundPosition: "50% 18%",
              }}
              aria-label="STK Komfort Znojmo logo"
            />
            <div className="leading-tight">
              <div className="font-heading text-base sm:text-lg font-bold text-white tracking-wide">
                STK Komfort
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-amber-300/80">
                Znojmo
              </div>
            </div>
          </a>

          <nav className="hidden xl:flex items-center gap-7" aria-label="Hlavní">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`nav-link-${l.id}`}
                className="text-sm font-medium text-slate-300 hover:text-amber-300 transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="https://www.facebook.com/stkkomfortznojmo"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-facebook-link"
              aria-label="Facebook STK Komfort Znojmo"
              title="Facebook STK Komfort Znojmo"
              className="hidden sm:inline-flex h-10 w-10 items-center justify-center rounded-lg text-white hover:opacity-90 hover:-translate-y-0.5 transition-all shadow-[0_6px_16px_-6px_rgba(24,119,242,0.6)]"
              style={{ backgroundColor: "#1877F2" }}
            >
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.24 10.44 22v-7.03H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.57v1.88h2.78l-.44 2.9h-2.34V22C18.34 21.24 22 17.08 22 12.06z"/>
              </svg>
            </a>
            <a
              href={`tel:${PHONE.replace(/\s+/g, "")}`}
              data-testid="header-call-btn"
              className="hidden sm:inline-flex items-center gap-2 rounded-lg bg-gradient-to-b from-amber-300 to-amber-500 hover:from-amber-200 hover:to-amber-400 px-4 py-2.5 text-sm font-semibold text-slate-900 shadow-[0_8px_20px_-6px_rgba(212,175,55,0.5)] transition-all hover:-translate-y-0.5"
            >
              <Phone className="h-4 w-4" />
              <span className="hidden md:inline">{PHONE}</span>
              <span className="md:hidden">Zavolat</span>
            </a>
            <button
              type="button"
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="xl:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-white"
              aria-label="Otevřít menu"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="xl:hidden pb-6" data-testid="mobile-menu">
            <nav className="flex flex-col gap-1 border-t border-white/10 pt-4">
              {links.map((l) => (
                <a
                  key={l.id}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${l.id}`}
                  className="rounded-lg px-3 py-3 text-sm font-medium text-slate-200 hover:bg-white/5 hover:text-amber-300"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={`tel:${PHONE.replace(/\s+/g, "")}`}
                data-testid="mobile-call-btn"
                className="mt-2 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-b from-amber-300 to-amber-500 px-4 py-3 text-sm font-bold text-slate-900"
              >
                <Phone className="h-4 w-4" />
                Zavolat Lence
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
